import { HOT_COUNTRIES_INDICATORS_KEY } from './constants';

export const generateIndicatorsKey = (key) => HOT_COUNTRIES_INDICATORS_KEY.replace('{key}', key).split('.');
